/**
 * ログイン状態の判定（BR-U6-2）。
 * U6タグは自前のセッション管理・トークン保持を行わない。
 *
 * ログイン状態はpolaris-mono側がサーバ側セッション（会員ID/ロール）で判定し、中継エンドポイントの
 * レスポンスヘッダー`X-Spica-Logged-In`で通知する（ヘッダー等の既存ログイン出し分けと同じ判定ソース）。
 * `fetchScenario`（resolve呼び出し）がこのヘッダー値を{@link setLoggedIn}で反映し、
 * レンダリング時に{@link isLoggedIn}が参照する。
 */

/** 中継レスポンス（X-Spica-Logged-In）から反映される現在のログイン状態. */
let loggedInState = false;

/**
 * サーバ判定のログイン状態を設定する（中継レスポンス受信時に呼ぶ）。
 */
export function setLoggedIn(value: boolean): void {
  loggedInState = value;
}

/**
 * 現在のログイン状態を返す。
 * 値は直近の中継エンドポイントのレスポンス（{@link setLoggedIn}）に基づく。
 */
export function isLoggedIn(): boolean {
  return loggedInState;
}
